import { render, staticRenderFns } from "./CampsContent.vue?vue&type=template&id=21e4c940&scoped=true&"
import script from "./CampsContent.vue?vue&type=script&lang=js&"
export * from "./CampsContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e4c940",
  null
  
)

export default component.exports